import { Injectable, inject } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from "@angular/common/http";
import { Observable, } from "rxjs";
import { finalize, shareReplay, switchMap } from "rxjs/operators";
import { RestUserExternal } from "../web-api/web-api";
import { UserService } from "../services/user.service";

@Injectable()
export class AuthRefreshInterceptor implements HttpInterceptor {
  private readonly _expiryBufferSeconds = 5;
  private readonly _userService = inject(UserService);
  private _refreshRequest$?: Observable<RestUserExternal | undefined>;

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    if (!this.shouldRefreshBeforeRequest(request)) {
      return next.handle(request);
    }
    return this.refreshToken$().pipe(switchMap(() => next.handle(request)));
  }

  private shouldRefreshBeforeRequest(request: HttpRequest<any>): boolean {
    if (
      this.isAnonymousRequest(request.url) ||
      !this._userService.CurrentUser
    ) {
      return false;
    }

    const tokenExpiry = this._userService.TokenExpiry;
    if (!tokenExpiry) {
      return false;
    }

    const nowInSeconds = Math.floor(Date.now() / 1000);
    const isExpiredOrAboutToExpire =
      tokenExpiry <= nowInSeconds + this._expiryBufferSeconds;
    return isExpiredOrAboutToExpire;
  }

  private refreshToken$(): Observable<RestUserExternal | undefined> {
    if (!this._refreshRequest$) {
      this._refreshRequest$ = this._userService.RefreshToken().pipe(
        finalize(() => {
          this._refreshRequest$ = undefined;
        }),
        shareReplay(1),
      );
    }
    return this._refreshRequest$;
  }

  private isAnonymousRequest(url: string): boolean {
    return (
      url.toLowerCase().includes("/api/login") ||
      url.toLowerCase().includes("/api/v2/auth/refresh")
    );
  }
}
